import React from 'react';
import Navbar from '../../../components/navbar/navbar';

const Heroic = () => {

    return (
        <div className="relative bg-white overflow-hidden" id="heroic">

            <div className="max-w-7xl mx-auto">

                <div className="relative z-10 pb-8 bg-white sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-7xl lg:pb-28 xl:pb-32  h-fit  sm:h-screen">

                    <svg
                        className="hidden lg:block absolute right-0 inset-y-0 h-full w-48 text-white transform translate-x-1/2"
                        fill="currentColor"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="none"
                        aria-hidden="true"
                    >
                        <polygon points="50,0 100,0 50,100 0,100" />
                    </svg>
                    <Navbar />

                    <main className="mt-10 mx-auto max-w-full px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28 custom_heroic_class">
                        <div className="sm:text-center lg:text-left">
                            <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                                <span className="block xl:inline">Smart Solution</span>{' '}<br />
                                <span className="block text-[#1D7ADF] xl:inline">Fast-Easy-Convenience</span>
                            </h1>
                            <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                                Design especially for small and medium organizations
                            </p>
                            <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                                <div className="rounded-md shadow">
                                    <a
                                        href="/docs"
                                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#1D7ADF] hover:bg-indigo-700 md:py-4 md:text-lg md:px-10"
                                    >
                                        Get started
                                    </a>
                                </div>
                                <div className="mt-3 sm:mt-0 sm:ml-3">
                                    <a
                                        href="/download"
                                        className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-[#1D7ADF] bg-indigo-100 hover:bg-indigo-200 md:py-4 md:text-lg md:px-10"
                                    >
                                        Download
                                    </a>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>


            <div className="lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2">
                <img
                    // className="h-56 w-full object-cover sm:h-90 md:h-100 lg:w-full lg:h-full"
                    // src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
                    className="h-full sm:h-56 w-full object-cover sm:h-90 md:h-100 lg:w-full lg:h-full"
                    src={require('../../../assets/pictures/bg_home_stggs.png')}
                    alt=""
                />
            </div>

        </div>
    )
}

export default Heroic;